import { PageTitle, PageTitleContainer } from "@/ui-components/utils/menu-items/page-title";
import SalesRankEditor from "../sales-rank-editor";

const CreateSalesRank = () => {
  return (
    <div>
      <PageTitleContainer>
        <div className="flex flex-row justify-between items-center">
          <PageTitle>Neuen Verkaufsrang erstellen</PageTitle>
        </div>
      </PageTitleContainer>
      <div className="p-4 w-1/2 items-center m-auto">
        <SalesRankEditor />
      </div>
    </div>
  );
};

export default CreateSalesRank;
